import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "./resume.scss";

const Resume = () => {
  const [data, setData] = useState({});

  const fetchProjects = async (project_title) => {
    try {
      const response = await fetch(`/${project_title}.json`); // Assuming `html.json` is in the public folder
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects("resume"); // Fetch default projects on initial render
  }, []);
  return (
    <>
      <section className="resume py-5" id="resume">
        <Container className="container py-lg-5 py-4">
          <div className="text-center mb-sm-5 mb-5">
            <h5 className="title-small text-uppercase">Resume</h5>
            <h3 className="fs-1 fw-bold ">Awesome Journey</h3>
          </div>
          <Row className="">
            <Col xs={24} md={6} className="">
              <h5 className="fs-2 pb-2">
                <i className="fas fa-graduation-cap"></i> Education
              </h5>
              <div className="ms-4 my-3">
                {data?.educations?.map((education, index) => (
                  <div className="column p-4 m-2 mb-4 border border-danger rounded-3">
                    <h2 className="fs-4">{education.degree}</h2>
                    <p className="fs-6">{education.institution}</p>
                    <h6>
                      <i className="fas fa-calendar-alt"></i> {education.year}
                    </h6>
                  </div>
                ))}
              </div>
            </Col>

            <Col xs={12} md={6} className="mt-lg-0 mt-4">
              <h5 className="fs-2 pb-2">
                <i className="fas fa-briefcase"></i> Experience{" "}
                {data.exp_years ? data.exp_years : ""}
              </h5>
              {data?.experiences?.map((experience, index) => (
                <div className="ms-4 my-3">
                  <div className="column p-4 m-2 mb-4 border border-danger rounded-3">
                    <h2 className="fs-4">{experience.post}</h2>
                    <p className="fs-6">{experience.company}</p>
                    <p>{experience.desc}</p>
                    <h6>
                      <i className="fas fa-calendar-alt"></i> {experience.date}
                    </h6>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Resume;
